import { useTranslation } from 'react-i18next';
import { ReferenceChatType } from '@/entities/references/api/generated/model';
import { useSessionStore } from '@/entities/session/model/sessionStore';
import { VITE_CONTACT_EMAIL } from '@/shared/lib/env';
import { buildMailtoHref } from '@/shared/lib/mail-templates/build-mailto-href';
import prefecturalGrantsRequestTemplate from '@/shared/lib/mail-templates/prefectural-grants-request.json5';
import prefecturalSpecialAllocationTaxesRequestTemplate from '@/shared/lib/mail-templates/prefectural-special-allocation-taxes-request.json5';
import { Button, Text } from '@/shared/ui';
import { SearchIcon } from './SearchIcon';

type Props = {
  chatType: ReferenceChatType;
};

// 動的キー禁止ルール準拠の明示マップで chatType ごとのメールテンプレを切替
const getMailTemplate = (chatType: ReferenceChatType) => {
  if (chatType === ReferenceChatType.prefectural_special_allocation_taxes) {
    return prefecturalSpecialAllocationTaxesRequestTemplate;
  }
  return prefecturalGrantsRequestTemplate;
};

export const NotSupportedAIAnalysisContent = ({ chatType }: Props) => {
  const { t } = useTranslation();
  const { user } = useSessionStore();

  const mailtoHref = buildMailtoHref(getMailTemplate(chatType), {
    replacements: {
      tenantName: user?.tenant?.name ?? '',
      localGovernmentCode: user?.tenant?.localGovernmentCode ?? '',
      userName: user?.name ?? '',
      userEmail: user?.email ?? '',
    },
  });

  return (
    <div className="flex flex-col items-center gap-2 py-6">
      <SearchIcon />
      <Text variant="label">{t('ai.analysis.not-supported-title')}</Text>
      <Text variant="description" className="text-center">
        {t('ai.analysis.not-supported-description')}
      </Text>
      <Button
        variant="outline"
        size="sm"
        className="mt-2"
        onClick={() => {
          window.location.href = mailtoHref;
        }}
      >
        {t('ai.analysis.send-request')}
      </Button>
      <Text variant="description" className="mt-2 text-center">
        {t('common.mailto-note')}
        <br />
        <Text variant="link" href={`mailto:${VITE_CONTACT_EMAIL}`}>
          {VITE_CONTACT_EMAIL}
        </Text>
      </Text>
    </div>
  );
};
